exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-13-wrapper[data-v-6e4fc2c2]{width:180px;padding-bottom:10px}.listing-img[data-v-6e4fc2c2]{width:20px;height:20px;border-radius:50%}", ""]);

// exports
